import { CircleAlertIcon, CircleCheckIcon, Loader2Icon, MinusIcon } from "~/icons/solar-lucide";

import { cn } from "~/lib/utils";

export type WorkStepLifecycleState = "inProgress" | "completed" | "failed" | "neutral";

const SIZE = {
  sm: { completed: "size-3.5", loader: "size-3" },
  md: { completed: "size-4", loader: "size-3.5" },
} as const;

/** Compact lifecycle chrome for agent steps and work-log tool rows. */
export function WorkStepLifecycleIndicator({
  state,
  size = "sm",
  className,
}: {
  readonly state: WorkStepLifecycleState;
  readonly size?: keyof typeof SIZE;
  readonly className?: string;
}) {
  const dim = SIZE[size];

  if (state === "inProgress") {
    return (
      <Loader2Icon
        aria-hidden
        className={cn(dim.loader, "shrink-0 animate-spin text-info", className)}
      />
    );
  }

  if (state === "failed") {
    return (
      <CircleAlertIcon
        aria-hidden
        className={cn(dim.completed, "shrink-0 text-destructive", className)}
      />
    );
  }

  if (state === "completed") {
    return (
      <CircleCheckIcon
        aria-hidden
        className={cn(dim.completed, "shrink-0 text-success", className)}
      />
    );
  }

  return (
    <MinusIcon
      aria-hidden
      className={cn(dim.loader, "shrink-0 text-muted-foreground opacity-70", className)}
    />
  );
}

export function morrowToolCallLifecycleState(status: string): WorkStepLifecycleState {
  if (status === "running") {
    return "inProgress";
  }
  if (status === "failed") {
    return "failed";
  }
  return "completed";
}
